import React from 'react';
import { Pagination } from './Pagination';
export var PaginationContainer = function PaginationContainer(_ref) {
  var currentPage = _ref.currentPage,
    totalPages = _ref.totalPages,
    updateCurrentPageNumber = _ref.updateCurrentPageNumber;
  var onPageChange = function onPageChange(currentPage) {
    updateCurrentPageNumber(currentPage);
    window.scrollTo(0, 0);
  };
  if (totalPages <= 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-flex grid-justify-center padding-bottom-xxl"
  }, /*#__PURE__*/React.createElement(Pagination, {
    currentPage: currentPage,
    totalPages: totalPages,
    onChange: onPageChange
  }));
};